<template>
  <div v-click-outside="closeSidebar" v-if="isDesktop" style="position: absolute" ref="left_sidebar">
    <SidebarForMenu ref="sidebar1"
                    v-model:visible="isFirstSidebarOpen"
                    position="left" :showCloseIcon="false"
                    :baseZIndex="400" class="sidebar1 layout-leftmenu">
      <div class="sidebar">
        <ul class="cursor-auto" style="margin: 0">
          <li><a @click="closeSidebar()" class="cursor-auto" style="font-size: 14px; font-weight: 600; padding: 22px 20px; display: flex;
              line-height: 24px; justify-content: space-between;" href="#">{{ $t('monitor_indicators') }}</a></li>
        </ul>
        <hr class="my-0">
        <ul class="cursor-pointer" style="margin: 0">
          <li v-for="(link, key) in menuLinks" :key="link"><a
            class="flex align-items-center justify-content-between"
            :class="{'active': secondSidebarName == key}"
            @click="openSecondMenu(key)">{{ $t(key) }}
            <i
              :class="{
                  'pi pi-chevron-left': secondSidebarName == key,
                  'pi pi-chevron-right': secondSidebarName != key
                }"
              style="font-size: 9px; color: rgb(51, 51, 51, 0.9);"
            />
          </a></li>
        </ul>
      </div>
    </SidebarForMenu>
    <SidebarForMenu ref="sidebar2"
                    style="left: 21.5rem; top: 4rem; height: calc(100vh - 3.8rem); z-index: 800; width: 29.5rem;"
                    v-model:visible="isSecondSidebarOpen"
                    position="left" :showCloseIcon="false"
                    :baseZIndex="400" class="layout-leftmenu">

      <div class="sidebar">
      <span style="position: relative; height: 68px;"
            class="flex align-items-center justify-content-center sidebar-input sidebar-width p-input-icon-left">
          <i style="left: 2rem" class="pi pi-search"/>
          <InputText class="sidebar-width p-inputtext-sm" style="font-size: 1rem;" v-model="searchValue" :placeholder="$t('search')"/>
      </span>
        <hr style="border-top-color: white" class="my-0">
        <ul style="margin: 0">
          <li :key="key" v-for="(link, key) in secondFilteredMenuValues">
            <component @click="closeSidebar()" class="flex align-items-center justify-content-between"
                       :class="{'isDisabled': link.to === ''}"
                       :is="link.to == '' ? 'span' : 'router-link'"
                       :to="{name: 'report_layout',query: {report_name: key},
                           params: {report_id: link.to ? link.to: 'none'}}">
              <text style="padding-left: 20px">{{ $t(key) }} </text>
            </component>
          </li>
        </ul>

      </div>
    </SidebarForMenu>
    <div class="overlay" v-if="isFirstSidebarOpen" @click="closeSidebar"></div>
  </div>
</template>

<script>
import SidebarForMenu from "@/primevue/sidebar/SidebarForMenu.vue";
import vClickOutside from 'v-click-outside'
import {mapGetters} from "vuex";

export default {
  name: "AppLeftPanel",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {SidebarForMenu},
  data() {
    return {
      isFirstSidebarOpen: false,
      isSecondSidebarOpen: false,
      isThirdSidebarOpen: false,
      innerWidth: window.innerWidth,
      searchValue: '',
      secondSidebarName: '',
      thirdSidebarName: '',


    }
  },
  methods: {
    closeSidebar() {
      this.isFirstSidebarOpen = false;
      this.isSecondSidebarOpen = false;
      this.thirdSidebarName = '';
      this.secondSidebarName = '';
      document.body.removeEventListener('click', this.eventCloseSidebar)
    },
    show() {
      if (this.isFirstSidebarOpen) {
        this.closeSidebar();
      } else {
        this.closeSidebar();
        this.isFirstSidebarOpen = true;
        this.isSecondSidebarOpen = false;
        this.secondSidebarName = '';
        setTimeout(() => {
          document.body.addEventListener('click', this.eventCloseSidebar)
        }, 100)
      }
    },
    openSecondMenu(name) {
      this.searchValue = '';
      this.thirdSidebarName = '';
      if (this.secondSidebarName == name && this.thirdSidebarName == '') {
        this.isSecondSidebarOpen = false;
        this.secondSidebarName = '';
      } else {
        this.isSecondSidebarOpen = true;
        this.secondSidebarName = name;
      }
      if (this.thirdSidebarName != '') {
        if (this.secondSidebarName != name) { // add this line
          this.isThirdSidebarOpen = false;
          this.thirdSidebarName = '';
        }
        this.isSecondSidebarOpen = false;
        this.secondSidebarName = '';
      }
    },
    setThirdSidebarName(name) {
      if (this.thirdSidebarName == name) {
        this.thirdSidebarName = '';
      } else {
        this.thirdSidebarName = name;
      }
      this.isThirdSidebarOpen = false; // add this line
    },

    eventCloseSidebar(event) {
      if (!this.$refs.left_sidebar.contains(event.target)) {
        this.closeSidebar()
      }
    },
    filterMenuByPermission(menu) {
      let filteredMenu = {};

      for (let key in menu) {
        let hasPermission = true; // Default to true for public links

        if (menu[key].permissions) {
          // Check permissions if they are specified
          hasPermission = menu[key].permissions.some(permission => this.checkPermission(permission));
        }

        if (hasPermission) {
          if (menu[key].subMenu) {
            let subMenu = this.filterMenuByPermission(menu[key].subMenu);
            if (Object.keys(subMenu).length > 0) {
              filteredMenu[key] = { ...menu[key], subMenu };
            }
          } else {
            filteredMenu[key] = menu[key];
          }
        }
      }

      return filteredMenu;
    },
    removeSectionsWithoutTo(obj) {
      for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          if (Object.prototype.hasOwnProperty.call(obj[key], 'to') && obj[key].to === "") {
            delete obj[key];
          } else {
            this.removeSectionsWithoutTo(obj[key]);
            if (Object.keys(obj[key]).length === 0) { // check if the section is now empty
              delete obj[key];
            }
          }
        } else if (typeof obj[key] === 'string' && obj[key] === "") {
          delete obj[key];
        }
      }
      return obj;
    }

},

  computed: {
    ...mapGetters({
      checkPermission: 'checkPermission'
    }),
    menuLinks() {
      let menu = {};
      if (this.checkPermission(['all', 'monitor', 'salem'])) {
        menu = {
          "execution_tasks": {
            "hardware_order_execution": {"to": "006ec56e-55a7-43ed-9f6f-74c302358fb4"},
            "operation_plan_execution": {"to": "f5a239a2-004f-4c08-af20-b4df8b5c0fcc"},
            "report_kpi": {"to": "ab5916a4-ce8a-41f3-912c-e3fa5a291427"},
          },
          "academic_work": {
            "students": {"to": ""},
            "student_performance_and_GPA": {"to": ""},
            "course_performance_and_GPA": {"to": ""},
            "grade_distribution_bell_curve": {"to": ""},
            "qualitative_knowledge_performance": {"to": ""},
          },
          "financial_economic_activity": {
            "implementation_development_plan": {"to": ""},
            "procurement_plan_execution": {"to": ''},
            "student_debts": {"to": ''},
            "profit_and_loss": {"to": ''},
            "cash_flow": {"to": ""},
            "salary_fund": {"to": ""},
            "travel_expenses": {"to": ""},
            "GPH_agreements": {"to": ""},
          },
          "managing_director": {
            "report_it": {"to": "8ebd9a55-b4d8-412f-86f7-cc34159fef54"},
          }
        };
      }
      if (!this.checkPermission(['all'])) {
        menu = this.removeSectionsWithoutTo(menu);
      }
      return menu;
    },


    isDesktop() {
      return this.innerWidth > 991;
    },
    openSecondMenuValues() {
      let list = {}
      if (this.secondSidebarName)
        list = this.menuLinks[this.secondSidebarName];
      return list
    },
    secondFilteredMenuValues() {
      const filtered = {};
      for (const key in this.openSecondMenuValues) {
        const value = this.openSecondMenuValues[key];
        if (this.$t(key).toLowerCase().includes(this.searchValue.toLowerCase())) {
          filtered[key] = value;
        } else if (typeof value === 'object') {
          const subFiltered = {};
          for (const subKey in value) {
            const subValue = value[subKey];
            if (this.$t(subKey).toLowerCase().includes(this.searchValue.toLowerCase())) {
              subFiltered[subKey] = subValue;
            }
          }
          if (Object.keys(subFiltered).length > 0) {
            filtered[key] = subFiltered;
          }
        }
      }
      return filtered
    },
    secondMenuLinksList() {
      const sorted = {};
      Object.keys(this.secondFilteredMenuValues)
        .sort((a, b) => a.localeCompare(b))
        .forEach(key => {
          sorted[key] = this.secondFilteredMenuValues[key];
        });
      return sorted;
    },

  },
  mounted() {
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth
    })
  },
  beforeUnmount() {
    document.body.removeEventListener('click', this.eventCloseSidebar)
  },
}
</script>


<style scoped>
.sidebar {

  height: 100%;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
}

.sidebar-open {
  left: 0;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

li {
  margin: 0;
  padding: 0;
}

a {
  display: block;
  padding: 10px 10px 10px 20px;
  color: #333;
  text-decoration: none;
  font-size: 1em;
}

span {
  display: block;
  padding: 10px 10px 10px 20px;
  color: #333;
  text-decoration: none;
  font-size: 1em;
}

.active {
  outline-width: 0 !important;
  background-color: var(--primary-lightest-color) !important;
  color: var(--primary-menu-text-color) !important;
}

input {
  border-radius: 0px;
}

.sidebar-width {
  width: 100%;
}

.sidebar-input {
  padding: 10px 20px;
}

a:hover {
  color: #333;
  background-color: #f2f2f2;
}

span:hover {
  color: #333;
  background-color: #f2f2f2;
}

.isDisabled {
  color: currentColor;
  cursor: auto;
  opacity: 0.5;
  text-decoration: none;
}

.sidebar1 {
  left: 4.5rem;
  top: 4rem;
  height: calc(100vh - 3.8rem);
  z-index: 801;
  width: 17rem;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 399;
}
</style>
